/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MainMenuService {
  private url = 'app/config/mainmenu.config.json';

  constructor(private http: HttpClient) {}

  public getMenuItems() {
    return this.http.get(this.url.toString()).toPromise();
  }
}
